import React from "react";
import "./style.scss";
import successModalIcon from "../../assets/icons/successModalIcon.svg";
import backdropL1 from "../../assets/icons/backdrop-SL1.svg";
import backdropL2 from "../../assets/icons/backdrop-SL2.svg";
import backdropL3 from "../../assets/icons/backdrop-SL3.svg";
import backdropR1 from "../../assets/icons/backdrop-SR1.svg";
import backdropR2 from "../../assets/icons/backdrop-SR2.svg";
import backdropR3 from "../../assets/icons/backdrop-SR3.svg";

function SuccessModal({ setModalOpen, title, desc, btnText }) {
  return (
    <div className="success_modal_overlay">
      <div className="success_modal_container_top">
        <div className="success_icon">
          <img src={successModalIcon} alt="successful tick" />{" "}
        </div>
      </div>
      <div className="success_modal_container">
        <div className="success_modal_container_bottom">
          <h1>Success!</h1>
          <p>{desc}</p>
          <div className="middle-wrapper">
            <div className="backdrop-left">
              <img className="backdropL1" src={backdropL1} alt="backdropL1" />
              <img className="backdropL2" src={backdropL2} alt="backdropL2" />
              <img className="backdropL3" src={backdropL3} alt="backdropL3" />
            </div>
            <div className="backdrop-right">
              <img className="backdropR3" src={backdropR3} alt="backdropR3" />
              <img className="backdropR2" src={backdropR2} alt="backdropR2" />
              <img className="backdropR1" src={backdropR1} alt="backdropR1" />
            </div>
          </div>
        </div>
      </div>
      <div className="bottom-wrapper">
        <button
          className="success_modal_close_btn"
          onClick={() => setModalOpen(false)}
        >
          {btnText}
        </button>
      </div>
    </div>
  );
}

export default SuccessModal;
